<template>
<el-dialog @close='cancel' title="添加话题" :visible.sync="dialogVisible" class="starSubject">
    <div class="add_goods_box">
        <div class="add_goods_search_box">
            <el-input placeholder="输入话题名称" v-model="param.subject" clearable></el-input>
            <el-button type="primary" @click="handelQuery" plain>搜索</el-button>
        </div>
        <div class="add_goods_tabs_box">
            <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
                <el-tab-pane :label="item.label" :name="item.name" v-for="(item,index) in activeList" :key="index">
                    <el-table :data="tableData" style="width: 100%" @select="handleSelectionChange" :ref="'multipleTable'+item.name" max-height="300">
                        <el-table-column type="selection" width="30"></el-table-column>
                        <el-table-column label="帖子/内容">
                            <template slot-scope="scope">
                                <div class="goods_item_box">
                                    <div>{{scope.row.objectname}}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="浏览数" prop="viewcount"></el-table-column>
                        <el-table-column label="创建时间" prop="datetime"></el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="sureAdd()">确 定</el-button>
    </div>
</el-dialog>
</template>

<script>
import {getStarTopicPageList} from 'api/shop'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'shop',
    data() {
        return {
            activeList: [{label: '帖子', name: '3'}, {label: '资料', name: '2'}],
            activeName: '3',
            param: {
                subject: '',
                datatype: '3'
            },
            page: {
                page: 0,
                pageSize: 10,
                pageCount: 0
            },
            dialogVisible: false,
            tableData: [],
            selectedResult: [],
            flag: true,
            scrollTop: 0 // 上一次滚动距离
        }
    },
    mounted() {},
    methods: {
        openDialog(selectedResult) {
            this.tableData = []
            this.selectedResult = $.extend(true, [], selectedResult)
            this.dialogVisible = true
            this._getList()
        },
        cancel() {
            this.param.name = ''
            this.page = {
                page: 0,
                pageSize: 10,
                pageCount: 0
            }
            this.dialogVisible = false
        },
        handelQuery() {
            this.page.page = 0
            this.tableData = []
            this._getList()
        },
        // 添加分组弹窗Tabs
        handleClick(tabName) {
            this.param.datatype = tabName
            this.page.page = 0
            this.tableData = []
            this._getList()
        },
        // 获取不同类型下商品列表
        _getList() {
            let selectedResult = this.selectedResult
            this.page.page++
            this.setLoading(true)
            getStarTopicPageList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = this.tableData.concat(data.data.content)
                    this.total = data.data.pageinfo.rowCount
                    this.page.pageCount = data.data.pageinfo.pageCount
                    if (selectedResult.length) {
                        this.tableData.forEach(obj1 => {
                            selectedResult.forEach(obj2 => {
                                if (obj1.objectid === obj2.objectid) {
                                    this.$nextTick(() => {
                                        this.$refs[`multipleTable${this.activeName}`][0].toggleRowSelection(obj1)
                                    })
                                }
                            })
                        })
                    }
                    this.setLoading(false)
                    let _this = this
                    this.$nextTick(() => {
                        $('.el-table__body-wrapper').scroll(function () {
                            let scrollTop = Math.floor(this.scrollTop)
                            let clientHeight = this.clientHeight
                            let scrollHeight = Math.floor(this.scrollHeight)
                            if (scrollTop + clientHeight === scrollHeight && _this.scrollTop !== scrollTop) {
                                if (_this.page.page < _this.page.pageCount) {
                                    _this.scrollTop = this.scrollTop
                                    _this._getList()
                                }
                            }
                        })
                    })
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
            this.setLoading(true)
        },
        handleSelectionChange(selection, row) {
            let flag = true
            this.selectedResult.forEach((obj1, index1) => {
                if (obj1.objectid === row.kmcinnerid) {
                    flag = false
                    // this.selectedResult.splice(index1, 1)
                    delete this.selectedResult[index1]
                }
            })
            if (flag) {
                let obj = $.extend(true, {}, row)
                obj.datetime = obj.datetime.substring(5, obj.datetime.length - 3)
                this.selectedResult.push(obj)
            }
            this.selectedResult = this.selectedResult.filter(obj => obj)
        },
        // 确定添加商品
        sureAdd() {
            this.$emit('setShop', this.selectedResult)
            this.cancel()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.starSubject{
    thead{
        .el-checkbox__input{
            display: none;
        }
    }
    .add_goods_box {
        .add_goods_search_box {
            display: flex;
            margin-bottom: 10px;
            .el-input {
                width: 240px;
            }
            .el-input__inner {
                height: 36px;
            }
            .el-input__icon {
                line-height: 36px;
            }
            .el-button,
            .el-button--mini {
                height: 36px;
                width: 96px;
                margin-left: 20px;
                margin-bottom: 0px;
            }
        }
        .add_goods_tabs_box {
            .el-table{
                min-height: 300px;
            }
            .goods_item_box {
                display: flex;
                align-items: center;
                & > img {
                    width: 74px;
                    min-width: 74px;
                    height: 42px;
                    margin-right: 10px;
                }
                & > div {
                    & > p:nth-of-type(1) {
                        color: rgba(48, 49, 51, 1);
                        line-height: 18px;
                        margin-bottom: 4px;
                        width: 420px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        word-break: break-all;
                    }
                    & > p:nth-of-type(2) {
                        line-height: 20px;
                    }
                    .free {
                        color: rgba(64, 158, 255, 1);
                    }
                    .toll {
                        color: #f56c6c;
                    }
                }
            }
            .el-table__empty-block {
                height: 340px;
                max-height: 340px;
            }
            .el-table__empty-text {
                position: relative;
                top: 80px;
            }
        }
        .el-tabs__header {
            padding-right: 20px;
        }
    }

}
</style>
